import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-media-gallery.css';
var getClassNameList = classNames.bind(styles);
var UitkMediaGallery = function (_a) {
  var name = _a.name;
  return React.createElement("div", {
    className: getClassNameList('uitk-media-gallery')
  }, name);
};
export { UitkMediaGallery };